import { apiCall } from "./servicesCall";

export const DASHBOARD_SERVICES = {
  getEvent(data) {
    return apiCall("/dashboard/event", data);
  },
};
